<button class="shareBtn facebook" (click)="shareOnFacebook($event)" type="button" mat-mini-fab aria-label="Share to facebook">
  <rma-icon glyph="social-facebook" />
</button>

<button class="shareBtn twitter" (click)="shareOnTwitter($event)" type="button" mat-mini-fab aria-label="Share to twitter">
  <rma-icon glyph="social-twitter" />
</button>

<button class="shareBtn linkedin" (click)="shareOnLinkedIn($event)" type="button" mat-mini-fab aria-label="Share to linkedin">
  <rma-icon glyph="social-linkedin" />
</button>
